// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"FAQPop_ConfirmationPop__B9Y-c","modalBody":"FAQPop_modalBody__zKgQ5"};